import _ from 'lodash';
import moment from 'moment';
import QueryString from 'query-string';
import Logger from './logger';

/** 
 * A utility module that defines a set of methods that perform common, often re-used functions.
 */

 const log = new Logger('COMPONENT_UTIL');

 /**
 * Pushes the new parameters to the URL.
 *
 * @export
 * @param {Object} location React router location object
 * @param {Object} history React router history object
 * @param {Object} params Parameters to be pushed
 * @param {Object} options Additional options 
 * @returns
 */
export function updateUrlParams(location, history, params, options={disableMonthYearSpecialValues: false, alias:{}, removal: []}) {
  log.debug('updateUrl() - location: %s, history: %s, params: %s, options: %s', location, history, params, options);
  if(!location || !history || !params) {
    return;
  }
  let newParams = Object.assign({}, params);
  Object.keys(newParams).forEach((key) => {
    if(_.isEmpty(newParams[key]+'')) {
      delete newParams[key];
    }
  });
  const dateRangeEmpty = _.isEmpty(newParams.startDate) && _.isEmpty(newParams.endDate);
  if((!options.disableMonthYearSpecialValues && ( _.isEmpty(newParams.date) && dateRangeEmpty && _.isEmpty(newParams.month)) || moment().format('M') === newParams.month)) {
    newParams.defaultMonth = 'now';
    delete newParams.month;
  } else {
    delete newParams.defaultMonth;
  }
  if((!options.disableMonthYearSpecialValues && ( _.isEmpty(newParams.date) && dateRangeEmpty && _.isEmpty(newParams.year)) || moment().format('YYYY') === newParams.year)) {
    newParams.defaultYear = 'now';
    delete newParams.year;
  } else {
    delete newParams.defaultYear;
  }
  if(!_.isEmpty(options.alias)) {
    Object.keys(newParams).forEach((key) => {
      let alias = options.alias[key];
      if(typeof alias === 'string' && !_.isEmpty(alias)) {
        newParams[alias] = newParams[key];
        delete newParams[key];
      }
    });
  }
  if(Array.isArray(options.removal) && !_.isEmpty(options.removal)) {
    options.removal.forEach(key => delete newParams[key]);
  }
  history.push({
      search: QueryString.stringify(newParams, {arrayFormat: 'index'})
  });
}

export default {
  updateUrlParams
};
